import { render, staticRenderFns } from "./list_form.vue?vue&type=template&id=17b01576&scoped=true&"
import script from "./list_form.vue?vue&type=script&lang=ts&"
export * from "./list_form.vue?vue&type=script&lang=ts&"
import style0 from "./list_form.vue?vue&type=style&index=0&id=17b01576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b01576",
  null
  
)

export default component.exports